exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promotion_config_pane .form_body[data-v-60919964]{display:grid;grid-template-columns:repeat(2, 1fr);gap:20px}", ""]);

// exports
